// extracted by mini-css-extract-plugin
export default {"zoomControls":"a_-z","zoomControlButton":"b_-z","zoomBanner":"c_-z","bannerButton":"d_-z","imageButton":"e_-z","zoom":"f_-z","zoomContent":"g_-z"};